import { gsap } from "gsap";
import barba from '@barba/core';
import barbaCss from '@barba/css';
import appUtils from './app_utils'
const $ = require('jquery')

const barbaTransitionDuration = 400


let pageViewInit = null
let pageViewDestroy = null
// https://barba.js.org/docs/advanced/hooks/
// https://barba.js.org/docs/advanced/views/
// https://barba.js.org/docs/userguide/syntax/
// https://barba.js.org/docs/getstarted/lifecycle/
// https://barba.js.org/docs/advanced/strategies/#prevent
// https://github.com/barbajs/barba/issues/526
const PageView = {
  namespace: 'page',

  // https://barba.js.org/docs/userguide/syntax/#lt-view-gt-object
  // https://barba.js.org/docs/advanced/hooks/
  afterEnter(data) { // async
    // using jsTransition, data.current.container and data.next.container in barba-wrapper
    // console.log('after-enter ' + $('#barba-wrapper').children().length)

    // whether using jsTransition, wrap pageViewInit in 10ms setTimeout, or use "after" transition hook
    // be sure that pageInit call occurs after pageDestroy, on one barba-container only!
    // await new Promise((resolve, reject) => {
    //  setTimeout(() => resolve(), 10)
    // });
    // console.log('after-enter--timeout ' + $('#barba-wrapper').children().length)
    pageViewInit(data.next.container)
  }
}

export const initLoader = function() {
}

export const goBarba = function(url) {
  barba.go(url)
}

export const initBarba = function(pageInit, pageDestroy, hooksAfter) {
  pageViewInit = pageInit
  pageViewDestroy = pageDestroy

  /*
  * Barba init after lazyLoadInstance creation
  */

  // disable browser scroll restoration
  // https://github.com/barbajs/barba/issues/158
  // https://github.com/barbajs/barba/issues/537
  // https://barba.js.org/docs/advanced/recipes/#Scroll-position

  // if ('scrollRestoration' in history) {
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  barba.use(barbaCss)

  // https://barba.js.org/docs/advanced/hooks/#Global-hooks
  // This will execute code everytime the hook is called in the lifecycle. What makes the hook global is that the definition is not wrap inside a Transition or a View. You can combine base and global hooks.

  // https://barba.js.org/docs/advanced/hooks/
  // do something before the transition starts
  barba.hooks.before((data) => {
    appUtils.$html.addClass('is-transitioning')

    appUtils.$html.removeClass(appUtils.navigationToggleClass)
  })

  barba.hooks.afterLeave((data) => {
    // console.log('after-leave ')
    // console.log($('#barba-wrapper').children())
    // data.current.container in barba-wrapper
    // console.log('before-leave ' + $('#barba-wrapper').children().length)

    if (data.next.url.hash) {
      if (data.next.url.hash === 'detail') {
        appUtils.scrollTo('#' + data.next.url.hash, 'auto', 0)
        // $('#sub-header--fixed').addClass('show');
      } else {
        setTimeout(function(){
          appUtils.scrollTo('#' + data.next.url.hash, 'auto', 800)
        }, 1200) // todo: wait for inline svg loading????????
      }
    } else {
      window.scrollTo(0, 0);
      // appUtils.scrollTo(0, 0, 200); // appUtils.$window.scrollTop(0); // document.body.scrollTop = 0;
    }

    pageViewDestroy(data.current.container)
  })

  // do something after the transition finishes
  barba.hooks.after((data) => {
    appUtils.$html.removeClass('is-transitioning')
    // https://barba.js.org/docs/userguide/analytics/
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
    if(typeof window.trackPageView === 'function') {
      window.trackPageView(window.location.pathname, document.title);
    }
    if(typeof hooksAfter === 'function') {
      hooksAfter(data)
    }
  })


  barba.init({
    // https://barba.js.org/docs/advanced/strategies/#Prefetch
    prefetchIgnore: true,

    //debug: true,
    views: [ PageView ],

    // https://barba.js.org/docs/plugins/css/
    // https://barba.js.org/docs/plugins/css/#Transition-hooks
    transitions: [{
      name: 'fade-transition',
      // sync true requires a rework on pageInit / pageDestroy logic
      sync: false,

      // using @barba/css plugin
      once() {},
      leave() {},
      enter() {}

      /*
      // js transiton without @barba/css plugin
      leave(data) {
        return gsap.to(data.current.container, {
          duration: (barbaTransitionDuration / 1000),
          opacity: 0
        });
      },
      enter(data) {
        return gsap.from(data.next.container, {
          duration: (barbaTransitionDuration / 1000),
          opacity: 0
        });
      }
      */
    }]
  });
}

export default {initLoader, initBarba, goBarba}
